import { apiClient } from "../../utils/apiClient";
import { Module } from "../../types/module";


export const fetchModules = (): Promise<Module[]> => {
    return apiClient.get("/modules").then((response) => response.data);
};

export const upsertModule = (module: Module): Promise<Module> => {
    return apiClient.post("/modules/upsertModule", module).then((response) => response.data);
};

export const getModuleByName = (moduleName: string): Promise<Module> => {
    return apiClient.get(`/modules/name/${moduleName}`).then((response) => response.data);
};


